import { PropsWithChildren } from 'react';

import { useFeature } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import { ContextSidebarLayout } from '../../../../context-sidebar';
import EvaluationSubmissionSidebar from '../../EvaluationSubmissionSidebar';

export default function EvaluationSubmissionSidebarLayout(
	props: PropsWithChildren<{
		id: string;
		user: graphql.User;
		isSideBarOpen: boolean;
		onSidebarOpen: (open: boolean) => void;
	}>,
) {
	const hasConversationContext = useFeature(graphql.FeatureName.EvaluationsContext);

	return (
		<ContextSidebarLayout
			isSideBarOpen={props.isSideBarOpen}
			onSidebarOpen={props.onSidebarOpen}
			renderSidebar={
				hasConversationContext
					? ({ onClose }) => (
							<EvaluationSubmissionSidebar
								onClose={onClose}
								conversationID={props.id}
								user={props.user}
							/>
						)
					: undefined
			}
		>
			{props.children}
		</ContextSidebarLayout>
	);
}
